import { GameService } from './../../services/game.service';

import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  LegacyGame as BaseGame,
  GameGradeABCEnum,
  GameModeEnum,
  GameResults,
  User,
} from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnUiButtonComponent } from 'onclass-ui';
import { Subject, takeUntil } from 'rxjs';
import { LessonReviewComponent } from '../lesson-review/lesson-review.component';
import { AccountService } from '../../services/account.service';
import { IconsService } from '../../services/icons.service';
import { GameStore } from 'lingo2-game-lib';
import { CustomLocaleModule } from '@onclass/oc-custom-locale';

@Component({
  selector: 'app-lesson-finish',
  standalone: true,
  imports: [
    OnUiButtonComponent,
    LessonReviewComponent,
    CustomLocaleModule
],
  templateUrl: './lesson-finish.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./lesson-finish.component.scss'],
})
export class LessonFinishComponent implements OnInit, OnDestroy {
  @Input() author!: User;
  @Input() lessonId = '';

  @Input() set game(game: BaseGame | any) {
    if (!game) {
      return;
    }
    this._game = game;
    this.results = new GameResults(game.results);
    this.setGradeABC();
  }
  get game() {
    return this._game;
  }

  @Input() set isShowConfirmation(finished: boolean) {
    this._isShowConfirmation = !finished;
  }

  public get isShowConfirmation() {
    return this._isShowConfirmation;
  }

  @Output() submitted = new EventEmitter<boolean>();
  // tslint:disable-next-line: no-output-native

  @Output() close = new EventEmitter<void>();
  @Output() authorRedirect = new EventEmitter<void>();
  @Output() checkout = new EventEmitter<void>();

  public svgSetIcon = IconsService.svgsetIconUrl;

  public _isShowConfirmation = true;
  public results: GameResults = new GameResults();
  public gradeABC = '';

  private _game: BaseGame = new BaseGame();
  private _me!: User;

  protected readonly destroyed$ = new Subject<boolean>();

  constructor(
    private gameService: GameService,
    private gameStore: GameStore,
    public deviceService: DeviceDetectorService
  ) {}

  public ngOnInit() {
    this.gameService.myUser$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (me) => {
        if (me) {
          this._me = me;
        }
      },
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public get isLessonWithTasks(): boolean {
    return this.results.total_max_points > 0;
  }

  public setGradeABC() {
    if (!this.results) {
      return;
    }
    const grade = GameResults.percentToGrageABC(this.results.percent);
    const symbols = {
      [GameGradeABCEnum.markAplus]: 'A+',
      [GameGradeABCEnum.markA]: 'A',
      [GameGradeABCEnum.markAminus]: 'A-',
      [GameGradeABCEnum.markBplus]: 'B+',
      [GameGradeABCEnum.markB]: 'B',
      [GameGradeABCEnum.markBminus]: 'B-',
      [GameGradeABCEnum.markCplus]: 'C+',
      [GameGradeABCEnum.markC]: 'C',
      [GameGradeABCEnum.markCminus]: 'C-',
      [GameGradeABCEnum.markDplus]: 'D+',
      [GameGradeABCEnum.markD]: 'D',
      [GameGradeABCEnum.markDminus]: 'D-',
      [GameGradeABCEnum.markF]: 'F',
    };
    this.gradeABC = symbols[grade] || '?';
  }

  public onConfirm() {
    this.gameStore.forceFinishGame(this._game.id);
    // без lessonId портал сверяет второй сегмент с id урока и молча выбрасывает сообщение
    this.gameService.sendMessage(`gamelib::${this.lessonId}::finished::true`);
    this._isShowConfirmation = false;
  }

  public onContinue() {
    this.gameStore.goToFirstUnansweredSlide(this._game.id);
  }

  public onClose() {
    this.close.emit();
    // @TODO: Move to portal after finish
    // this.store.dispatch(updateMyGameStats());
  }

  public get isReadOnly() {
    return this._game && this._game.options && this._game.options.readOnly;
  }

  get isPreviewMode() {
    return (
      this._game &&
      this._game.options &&
      this._game.options.mode === GameModeEnum.preview
    );
  }

  public get isAuthor(): boolean {
    return !!this._me && !!this.author && this._me.id === this.author.id;
  }

  get authorFullName(): string {
    return this.author ? AccountService.getUserFullName(this.author) : '';
  }

  public openAuthorPage() {
    this.authorRedirect.emit();
  }

  public onSubmitted() {
    this.submitted.emit(true);
  }

  public onCheckout(): void {
    this.checkout.emit();
  }
}
